// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pixel-manager-mf .list[data-v-110312cf]{padding:0 8px 0 0}.pixel-manager-mf .icon[data-v-110312cf]{margin-top:-4px;margin-right:10px}.pixel-manager-mf .action-title[data-v-110312cf]{margin-top:12px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
